import { ApplicationConfigurationService } from '@src/core/application-configuration';
// @ts-ignore
const { SplunkRum } = globalThis;

const configuration = ApplicationConfigurationService.getConfiguration();

SplunkRum.init({
  beaconUrl: 'https://rum-ingest.eu0.signalfx.com/v1/rum',
  rumAuth: configuration.RUM_AUTH,
  app: 'cmp-srmp-web',
  environment: configuration.ENV,
});
export default SplunkRum;
